// lib/mutations/revokeUserSession.js

import { axios } from 'lib/axios';
import { useMutation } from 'react-query';

export const revokeUserSession = ({ data }) => {
  return axios.post('/session/user/revoke', data);
};

export const useRevokeUserSession = ({ config }) => {
  return useMutation({
    ...config,
    mutationFn: revokeUserSession,
  });
};
